// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--vGBUx","header":"index-module--header--1poZp","menu":"index-module--menu--oUYJS","content":"index-module--content--3rRyZ"};